module.exports = __webpack_public_path__ + "packs/media/bundles/Admin/AdminDoc-5d9fadff55beeb27da094375df4ed82d.md";